const RECOVERY_STORAGE_KEY = 'qbeek:chunk-load-recovery';

export function isChunkLoadError(error) {
  const name = String(error?.name || '');
  const message = String(error?.message || '');

  return (
    name === 'ChunkLoadError' ||
    /ChunkLoadError/i.test(message) ||
    /Loading (CSS )?chunk .+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

function getStorageKey() {
  const buildId = process.env.VUE_APP_BUILD_ID || 'unknown';
  return `${RECOVERY_STORAGE_KEY}:${buildId}`;
}

function buildReloadUrl(location) {
  const url = new URL(location.href);
  url.searchParams.set('_chunk_reload', String(Date.now()));
  return url.toString();
}

export function clearChunkLoadRecovery(storage = window.sessionStorage) {
  storage?.removeItem?.(getStorageKey());
}

export function recoverFromChunkLoadError(
  error,
  {
    location = window.location,
    storage = window.sessionStorage,
  } = {},
) {
  if (!isChunkLoadError(error)) {
    return false;
  }

  const storageKey = getStorageKey();
  if (storage?.getItem?.(storageKey)) {
    return false;
  }

  storage?.setItem?.(storageKey, '1');
  location.replace(buildReloadUrl(location));
  return true;
}
